import {
  //
  FETCH_NOTIFICATION,
  FETCH_NOTIFICATION_FAILURE,
  FETCH_NOTIFICATION_SUCCESS,
  ADD_NOTIFICATION,
  ADD_NOTIFICATION_SUCCESS,
  ADD_NOTIFICATION_FAILURE,
  TOGGLE_NOTI_MODAL,
} from "./constants";

// List
export const fetchNotification = (payload, onFetch) => ({
  type: FETCH_NOTIFICATION,
  payload,
  onFetch,
});
export const fetchNotificationSuccess = (payload) => ({
  type: FETCH_NOTIFICATION_SUCCESS,
  payload,
});
export const fetchNotificationFailure = (payload) => ({
  type: FETCH_NOTIFICATION_FAILURE,
  payload,
});

export const addNotification = (payload, onAdd) => ({
  type: ADD_NOTIFICATION,
  payload,
  onAdd,
});
export const addNotificationSuccess = (payload) => ({
  type: ADD_NOTIFICATION_SUCCESS,
  payload,
});
export const addNotificationFailure = (payload) => ({
  type: ADD_NOTIFICATION_FAILURE,
  payload,
});

export const toggleNotiModal = (payload) => ({
  type: TOGGLE_NOTI_MODAL,
  payload,
});
